import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { ShownOnDevice } from '../../../../common/ResponsiveContext';
import { selectors } from '../../slice/pizza.slice';
import { usePizzaCaloriesSelector } from '../../hooks/pizzaIngredientOptionsSelectors';
import styles from './PizzaSummary.styles';
import { usePizzaMeltDetector } from '@/hooks/usePizzaMeltDetector';

export interface PizzaSummaryProps {
  text?: string | null;
  noBorder?: boolean;
}

const PizzaSummary = (props: PizzaSummaryProps): JSX.Element => {
  const { text, noBorder } = props;
  const classes = styles();
  const isPizzaMelt = usePizzaMeltDetector();
  const summaryTitle = useSelector(selectors.selectPizzaSummaryTitle);
  const servings = useSelector(selectors.selectServings);
  const calories = usePizzaCaloriesSelector();
  const className = [classes.root, noBorder && classes.noBorder].join(' ');
  // FF
  return (
    <Grid className={className}>
      <Grid item>
        {summaryTitle && (
          <>
            {!isPizzaMelt && (
              <ShownOnDevice mdUp>
                <Typography
                  variant="h4"
                  component="p"
                  data-testid="pb-sub-header"
                >
                  {text}
                </Typography>
              </ShownOnDevice>
            )}
          </>
        )}
        {calories && servings && (
          <Typography data-testid="calories">
            {calories}, {servings}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default PizzaSummary;
